// extracted by mini-css-extract-plugin
export default {"avatar":"avatar-DAmjJ","pointer":"pointer-Imw2v","filled":"filled-dJT4l"};